import TravelRuleTableItemLoading from './TravelRuleTableItemLoading'

export default TravelRuleTableItemLoading
